export default "__VITE_ASSET__CbupbVds__"